import {UI, type UIChild} from "stem-core/ui/UIBase";
import {registerStyle, styleRule} from "stem-core/ui/Style";
import {StyleSheet} from "stem-core/ui/Style";


class CardItemsStyle extends StyleSheet {
    @styleRule
    cardItem = {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid rgba(27,126,140,0.18)",
        padding: "2px 0",
        fontSize: 14,
    };
}

interface CardItemsOptions {
    items: [UIChild, unknown][]; // Label/value pairs, the value stringified for display
}

@registerStyle(CardItemsStyle)
export class CardItems extends UI.Element<CardItemsOptions> {
    render() {
        const {items} = this.options;

        return items.map((item, index) => (
            <div key={index} className={this.styleSheet.cardItem}>
                <div>{item[0]}</div>
                <div>{String(item[1] || "-")}</div>
            </div>
        ));
    }
}
